import { SET_SHOW_GEOCODE_RESULTS } from '../actionTypes';
import { locationFormActions } from '../reducer';

export default (value, name) =>
    locationFormActions[SET_SHOW_GEOCODE_RESULTS]({
        name,
        payload: value,
    });
